export default __webpack_public_path__ + "static/media/noti.af4a25f6.mp3";